import { withAuthenticationRequired } from "@auth0/auth0-react";
import React from "react";
import { Loading } from "./Loading";
import { Error } from './Error';
import { useAuth0 } from "@auth0/auth0-react";

interface AuthenticationGuardProps {
  component: React.ComponentType<any>;
}

const AuthenticationGuard: React.FC<AuthenticationGuardProps> = ({
  component: Component,
}) => {
  const { error } = useAuth0();

  if (error) {
    return <Error message={error.message} />;
  }

  const AuthenticatedComponent = withAuthenticationRequired(Component, {
    onRedirecting: () => (
      <div className="page-layout">
        <Loading />
      </div>
    ),
  });

  return <AuthenticatedComponent />;
};

export default AuthenticationGuard;
